<div
  class="dialogue-container"
  [ngClass]="{
    'embedded-container': isEmbedded,
    'dialogue-info-container': dialogue?.dialogueBlock?.type === dialogueBlockType.information
  }">
  <div class="close-dialogue" *ngIf="closeableDialogue && !isPulseSurvey && !isQuestCard && !isEmbedded">
    <button
      class="close-button"
      *ngIf="
        dialogueDataStatus?.status !== status.starting && dialogue?.dialogueBlock?.type !== dialogueBlockType.terminate
      "
      (click)="closeDialogue()">
      &times;
    </button>
  </div>

  <ng-container
    *ngIf="
      keysChecked &&
      !noValidKeys &&
      (!dialogueDataStatus ||
        ((dialogueDataStatus?.status === status.done || dialogueDataStatus?.status === status.error) && !dialogue))
    ">
    <div class="no-reflection">
      <h2>There are no further questions at this time. Please try again later.</h2>
      <button class="button button-pill button-no-reflection" (click)="completeDialogue(false)">
        Return to {{ productName }}
      </button>
    </div>
  </ng-container>

  <ng-container [ngSwitch]="dialogue?.dialogueBlock?.type" *ngIf="!terminated">
    <ng-container *ngSwitchCase="dialogueBlockType.question">
      <kp-question
        *kutilRerender="dialogue?.dialogueBlock?.question?.id"
        [question]="dialogue?.dialogueBlock?.question"
        [isEmbedded]="isEmbedded"
        [keyType]="kumanuKeyType.logicKey"
        [key]="dialogueLogicKey"
        [individualBlockKey]="dialogue?.dialogueBlock?.data?.['question']?.['logicKey']"
        [userDialogueBlockId]="dialogue?.dialogueBlock?.id"
        (updatedQuestionAnswer)="updateQuestionAnswer($event)"
        (canAdvance)="isQuestionAnswered = $event"></kp-question>
      <kp-bottom-arrow-nav
        *ngIf="!isEmbedded"
        [showsBackButton]="dialogue?.dialogueBlock?.canUndo"
        [showsSkip]="
          (!dialogue?.dialogueBlock?.validation?.required || !dialogue?.dialogueBlock?.question?.settings?.required) &&
          !isQuestionAnswered
        "
        [showsNextButton]="isQuestionAnswered"
        [disableNextButton]="isSubmitted"
        (nextClick)="
          onSubmit(
            (!dialogue?.dialogueBlock?.validation?.required ||
              !dialogue?.dialogueBlock?.question?.settings?.required) &&
              !isQuestionAnswered
          )
        "
        (backClick)="onUndo()">
        <div *ngIf="displayProgressBar" class="progress-bar-container">
          <kp-progress-bar
            [max]="dialogue?.progress?.totalCount"
            [value]="dialogue?.progress?.blockIndex"
            [displayAsPercent]="true"></kp-progress-bar>
        </div>
      </kp-bottom-arrow-nav>
    </ng-container>
    <ng-container *ngSwitchCase="dialogueBlockType.dialogue_block_signup_sequence">
      <kp-dialogue-signup></kp-dialogue-signup>
      <!-- No bottom arrow nav needed. DialogueSignupComponent auto-advances the Dialogue when complete. -->
    </ng-container>
    <ng-container *ngSwitchCase="dialogueBlockType.information">
      <kp-dialogue-information [dialogue]="dialogue" [isEmbedded]="isEmbedded"></kp-dialogue-information>
      <button
        class="call-to-action button button-pill"
        *ngIf="dialogue?.dialogueBlock?.information?.buttonText"
        (click)="onSubmit()">
        {{ dialogue?.dialogueBlock?.information?.buttonText }}
      </button>
      <kp-bottom-arrow-nav
        *ngIf="!dialogue?.dialogueBlock?.information?.buttonText"
        [showsBackButton]="dialogue?.dialogueBlock?.canUndo"
        (backClick)="onUndo()"
        (nextClick)="onSubmit()"></kp-bottom-arrow-nav>
    </ng-container>
    <div class="no-reflection animation-display" *ngSwitchCase="dialogueBlockType.terminate">
      <kp-done-animation
        *ngIf="animating && showAnimation"
        (animationStateChange)="completeDialogue($event)"
        [doneMessage]="animationDoneMessage"></kp-done-animation>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="dialogueDataStatus?.status === status.starting && isEmbedded">
  <!--
    • Ensure this matches the shimmer in the dialogue status component so
      as to not have different shimmers when dialogue is embedded
    • Embedded dialogues now have a different size than normal dialogues so
      check for ng-deep if shimmers don't match
  -->
  <kp-shimmer class="dialogue-status-shimmer"></kp-shimmer>
  <kp-shimmer class="dialogue-status-shimmer"></kp-shimmer>
  <kp-shimmer class="dialogue-answer-shimmer"></kp-shimmer>
</ng-container>
